<script>
  import {
    fly
  } from 'svelte/transition';
</script>

<div transition:fly="{{ y: 50, duration: 200 }}" class="card">
  <p class="invert caption">Location Data Not Available<br>Press <strong>Play</strong> when you reach your destination</p>
</div>

<style>
  .card {
    width: 70vw;
    margin: 10px;
    position: absolute;
    z-index: 1500;
    background-color: #E71D36;
    text-align: center;
    padding: 0px;
  }
</style>
